module.exports = __webpack_public_path__ + "img/s3Model4.e3d76ef5.webp";